import { render } from "./MegaMenuMobile.vue?vue&type=template&id=685a112e&scoped=true"
import script from "./MegaMenuMobile.vue?vue&type=script&lang=js"
export * from "./MegaMenuMobile.vue?vue&type=script&lang=js"

import "./MegaMenuMobile.vue?vue&type=style&index=0&id=685a112e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685a112e"]])

export default __exports__